import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { useLayoutEffect, useRef, useState } from "react";
/**
 * A wrapper that preserves the size of its children when they are not visible.
 * Can be used to prevent layout shifts when conditionally rendering components.
 * Even though an alternative to set visibility: hidden is possible, this component
 * is a better approach to avoid screen readers reading hidden content or
 * manually change the visibility of the content in dev tools.
 */
export function PlaceholderWrapper(t0) {
  const $ = _c(12);
  const {
    shouldPreserveHeight: t1,
    shouldPreserveWidth: t2,
    isVisible,
    children
  } = t0;
  const shouldPreserveHeight = t1 === undefined ? true : t1;
  const shouldPreserveWidth = t2 === undefined ? true : t2;
  const ref = useRef(null);
  const [size, setSize] = useState(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (!ref.current) {
        return;
      }
      const updateSize = function updateSize() {
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          setSize({
            width: rect.width,
            height: rect.height
          });
        }
      };
      updateSize();
      const observer = new ResizeObserver(updateSize);
      observer.observe(ref.current);
      return () => observer.disconnect();
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== isVisible) {
    t4 = [isVisible];
    $[1] = isVisible;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  useLayoutEffect(t3, t4);
  if (isVisible) {
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        display: "inline-block"
      };
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    let t6;
    if ($[4] !== children) {
      t6 = <Box ref={ref} sx={t5}>{children}</Box>;
      $[4] = children;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    return t6;
  }
  const t5 = shouldPreserveWidth ? size?.width ?? "auto" : "0px";
  const t6 = shouldPreserveHeight ? size?.height ?? "auto" : "0px";
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = {
      width: t5,
      height: t6,
      visibility: "hidden",
      display: "inline-block"
    };
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== children || $[10] !== t7) {
    t8 = <Box sx={t7}>{children}</Box>;
    $[9] = children;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}